import React, { useEffect, useRef, useState } from 'react'
import { CloseButton } from 'components/UI/SuperButton/SuperButton'
import styles from './LeadChat.module.scss'
import { ReactComponent as Robot } from 'components/CRM/UI/icons/robot.svg'
import ChatInput from 'components/CRM/CustomerCardAndChat/Chat/ChatInput/ChatInput'
import { ReactComponent as WhatsApp } from 'components/CRM/UI/icons/whatsapp.svg'
import { superAxiosRequest } from 'axiosApi'
import ProfileAvatar from 'components/CRM/UI/components/ProfileAvatar/ProfileAvatar'
import Stores from 'Stores'

const LeadChat = ({
  handleChat,
  client,
  messages,
  setMessages,
  currentLead,
}) => {
  const [inputText, setInputText] = useState('')
  const [messageStatus, setMessageStatus] = useState(null)
  const [newMessageId, setNewMessageId] = useState(null)
  const socket = useRef()
  const messagesEndRef = useRef(null)
  const isFirstRender = useRef(true)

  const messageTypeStyles = (message) => {
    const messId = message?.data?.id === newMessageId

    if (messId) {
      return messageStatus === 1
        ? styles.sending
        : messageStatus === 2
          ? styles.success
          : null
    } else {
      return null
    }
  }

  const sendMessage = () => {
    if (!currentLead) return
    superAxiosRequest(
      {
        link: `integration/messages`,
        method: 'post',
        crm: true,
      },
      {
        session_id: currentLead.session_id,
        text: inputText,
      },
    )
      .then((res) => {
        setInputText('')
      })
      .catch()
  }

  useEffect(() => {
    if (currentLead?.session_id) {
      const link = 'communication_sessions'
      const wsUrl = `${Stores.baseLinkCRM().replace('https', 'wss')}/${link}/${currentLead.session_id}/?token=${localStorage.getItem('access')}`
      socket.current = new WebSocket(wsUrl)

      socket.current.onmessage = (e) => {
        const message = JSON.parse(e.data)
        switch (message.type) {
          case 'new_message':
            setNewMessageId(message.data?.data?.id)
            setMessages((prevMessages) => [...prevMessages, message.data])
            setMessageStatus(message.data?.data?.sending_status)
            break
          case 'update_message_sending_status':
            setMessageStatus(message.data?.data?.sending_status)
            break
          default:
            break
        }
      }

      socket.current.onerror = () => {
        console.log('Socket произошла ошибка')
      }

      return () => {
        socket.current.close()
      }
    }
    return () => {}
  }, [currentLead?.session_id])

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'auto' })
      // После первого рендера устанавливаем флаг в false
      isFirstRender.current = false
    }
  }, [messages])

  return (
    <div className={styles.wrapper}>
      <div className={styles.box}>
        <div className={styles.header}>
          <div className={styles.title}>{client || ''}</div>
          <CloseButton onClick={handleChat} />
        </div>
        <div className={styles.body}>
          <div className={styles.chatBox}>
            {messages.map((message, index) => {
              const error = message.data.sending_status === 3
              return (
                <div
                  key={index}
                  className={`${styles.messageContainer} ${message.data.sender_client ? styles.client : styles.manager}`}
                >
                  {message.data.sender_client ? (
                    <>
                      <div className={styles.clientAvatar}>
                        <ProfileAvatar name={client} />
                        <div className={styles.cycleForIcon}>
                          <div className={styles.whatsAppIcon}>
                            <WhatsApp />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`${styles.messageBlock} ${styles.clientBlock}`}
                      >
                        <p className={styles.message}>{message.data.text}</p>
                        <div className={styles.date}>
                          {new Date(message.data.sent_at).toLocaleString()}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className={`${styles.messageBlock} ${styles.managerBlock} ${messageTypeStyles(message)}`}
                      >
                        <p className={styles.message}>{message.data.text}</p>
                        <div className={styles.date}>
                          {new Date(message.data.sent_at).toLocaleString()}
                        </div>
                        {error && <div className={styles.errorNote}>error</div>}
                      </div>
                      <Robot />
                    </>
                  )}
                </div>
              )
            })}
            <div ref={messagesEndRef}></div>
          </div>
        </div>
        <ChatInput
          inputText={inputText}
          setInputText={setInputText}
          closeAttach={false}
          sendMessage={sendMessage}
        />
      </div>
    </div>
  )
}

export default LeadChat
